import "./base.js";

// This will be used to contain the confirmation modal state

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.ConfirmationModal = class ConfirmationModal extends (
  AppointmentBooking.SlotSuggester.Models.Base
) {
  defaults() {
    return { selectedDate: null };
  }
};

AppointmentBooking.SlotSuggester.Models.ConfirmationModal.prototype.relations = [
  {
    type: Backbone.HasMany,
    key: "slots",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
  },
];
